// extracted by mini-css-extract-plugin
export default {"dataRow":"TableItemRow_dataRow__LSLxB","itemCount":"TableItemRow_itemCount__TVoRR","itemTypeIcon":"TableItemRow_itemTypeIcon__wQ56y","nameLabel":"TableItemRow_nameLabel__aMPF1"};